var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject, optional } from '@patsnap/tahiti-core/shared/inversify';
import { ApiChangeCommentScope } from '@/infrastructure/api-functions/api-change-comment-scope';
import { CommentQueryGetter } from './comment-query-service.interface';
import { RavenService } from '../../../../../cores/modules/raven-module/raven-service';
/**
 * Change Comment Scope by All
 */
export const TRACK_CHANGE_COMMENT_SCOPE_BY_ALL = 'Change Comment Scope by All';
/**
 * Change Comment Scope by Selected
 */
export const TRACK_CHANGE_COMMENT_SCOPE_BY_SELECTED = 'Change Comment Scope by Selected';
let CommentsScopeServiceImp = class CommentsScopeServiceImp {
    constructor(_apiChangeCommentScope, _commentQueryGetter, _ravenService) {
        this._apiChangeCommentScope = _apiChangeCommentScope;
        this._commentQueryGetter = _commentQueryGetter;
        this._ravenService = _ravenService;
    }
    changeCommentScope(options) {
        if (options.allComments) {
            return this._changeCommentScopeWithQuery(options);
        }
        return this._changeCommentScopeWithoutQuery(options);
    }
    _changeCommentScopeWithQuery(options) {
        const commentQuery = this._commentQueryGetter?.getQuery();
        const request = {
            visible_scope: options.scope,
            query: {
                content: commentQuery.keyword,
                visible_scope: commentQuery.scope,
                comment_type: commentQuery.type,
                sort: commentQuery.sort,
                space_id: commentQuery.space,
            },
            all_comment: true,
            total_comment_count: options.totalCommentCount,
        };
        this._ravenService?.track(TRACK_CHANGE_COMMENT_SCOPE_BY_ALL);
        return this._changeCommentScope(request, options);
    }
    _changeCommentScopeWithoutQuery(options) {
        const request = {
            visible_scope: options.scope,
            data_id_list: options.commentIds,
        };
        this._ravenService?.track(TRACK_CHANGE_COMMENT_SCOPE_BY_SELECTED);
        return this._changeCommentScope(request, options);
    }
    async _changeCommentScope(request, options) {
        if (options.spaceId) {
            request.dst_space_id = options.spaceId;
        }
        const resp = await this._apiChangeCommentScope.changeCommentScope(request);
        return {
            taskDone: resp.task_done,
            updateCommentCount: resp.update_comment_count,
            selectCommentCount: resp.select_comment_count,
        };
    }
};
CommentsScopeServiceImp = __decorate([
    injectable(),
    __param(0, inject(ApiChangeCommentScope)),
    __param(1, optional()),
    __param(1, inject(CommentQueryGetter)),
    __param(2, optional()),
    __param(2, inject(RavenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof ApiChangeCommentScope !== "undefined" && ApiChangeCommentScope) === "function" ? _a : Object, typeof (_b = typeof CommentQueryGetter !== "undefined" && CommentQueryGetter) === "function" ? _b : Object, typeof (_c = typeof RavenService !== "undefined" && RavenService) === "function" ? _c : Object])
], CommentsScopeServiceImp);
export { CommentsScopeServiceImp };
